import { render, staticRenderFns } from "./chooseSubject2.vue?vue&type=template&id=8dbdf4f2&"
import script from "./chooseSubject2.vue?vue&type=script&lang=js&"
export * from "./chooseSubject2.vue?vue&type=script&lang=js&"
import style0 from "./chooseSubject2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports